const routes = {
	'/': '',

	'/campaign': 'Campaign',
	'/campaign/create': 'Create Campaign',
	'/campaign/edit': 'Edit Campaign',
	'/campaign/view': 'View Campaign',

	'/advertisement': 'Advertisments',
	'/advertisement/create': 'Create Advertisments',
	'/advertisement/edit': 'Edit Advertisments',
	'/advertisement/view': 'View Advertisments',

	'/screenshot': 'Screenshot',

	'/template': 'Layouts',
	'/template/create': 'Create',

	'/refund': 'Refund',

	'/feedback': 'Feedback',
	'/dashboard': 'Dashboard',
	'/reports': 'Reports',
	'/contentlibrary': 'Content Library',
};
export default routes;
